import React from 'react';
import { TippyTooltip } from '@bbkAdminComponents/tooltips/tippy-tooltip';
import { cs } from '@bbkAdminUtils/css-utils';
import { Icons } from '@bbkAdminUtils/icons';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

type Props = {
  id?: string;
  label?: string | React.ReactElement;
  helpText?: string | React.ReactElement;
  classes?: string;
  explain?: boolean;
} & React.DetailedHTMLProps<
  React.LabelHTMLAttributes<HTMLLabelElement>,
  HTMLLabelElement
>;

export const Label: ReactFCC<Props> = (props) => {
  const { id, label, classes, helpText, explain, children, ...restProps } =
    props;
  return (
    <label
      htmlFor={id}
      className={cs(
        'bbk-label-component tw-mb-[5px] tw-flex tw-items-center tw-text-sm tw-text-black/50 [&.error]:tw-text-[#FB315D]',
        explain && 'tw-italic',
        classes
      )}
      {...restProps}
    >
      {label || children}
      {helpText && (
        <TippyTooltip content={helpText}>
          <span className="bbk-label-help-text tw-flex tw-pl-1">
            {Icons.questionMark}
          </span>
        </TippyTooltip>
      )}
    </label>
  );
};
